import type { AmountInputMode } from "#/features/trade/components/order-form/stores/order-form-atoms.ts";

export type PriceSource = "manual" | "selected" | "autoLast";
export type SizeSource = "base" | "quote" | "percent";

export type OrderDraft = {
	price: {
		source: PriceSource;
		manualInput: string;
		selectedInput: string;
	};
	size: {
		source: SizeSource;
		input: string;
	};
};

export function createOrderDraft(
	amountInputMode: AmountInputMode,
	autoQuote: boolean,
): OrderDraft {
	return {
		price: {
			source: autoQuote ? "autoLast" : "manual",
			manualInput: "",
			selectedInput: "",
		},
		size: {
			source: amountInputMode === "amount" ? "base" : "quote",
			input: "",
		},
	};
}
